import { useEffect } from 'react';
import type { MasterDataInterfaceConfigurationResponse } from 'src/apis/assignment-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useOptionalMasterDataInterfaceConfiguration(url?: string) {
  const masterDataInterfaceConfiguration = useAxios(
    (axios, baseConfig, { url }: { url: string }) =>
      axios.request<MasterDataInterfaceConfigurationResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    masterDataInterfaceConfiguration.execute({ url });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  if (!url) return;

  return masterDataInterfaceConfiguration;
}

export type OptionalMasterDataInterfaceConfigurationRequest = ReturnType<
  typeof useOptionalMasterDataInterfaceConfiguration
>;
